import React from 'react';
import { Link } from 'react-router-dom';
import { SectionHeading } from '../ui/SectionHeading';
import { Card } from '../ui/Card';
import { ListIcon, BadgeCheckIcon, UserPlus2Icon, FileTextIcon, PackageIcon, LanguagesIcon, BriefcaseIcon, BarChart3Icon, ArrowRightIcon } from 'lucide-react';
import { useLang } from '../../lib/i18n/LanguageContext';
import { dictionary } from '../../lib/i18n/dictionary';
const icons = [ListIcon, BadgeCheckIcon, UserPlus2Icon, FileTextIcon, PackageIcon, LanguagesIcon, BriefcaseIcon, BarChart3Icon];
export function RevenueModel() {
  const {
    lang
  } = useLang();
  const t = dictionary.revenue;
  const c = dictionary.common;
  const items = t.items[lang];
  return <section id="revenue" className="py-24 md:py-32 bg-slate-50" data-id="element-468">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-469">
        <SectionHeading eyebrow={t.eyebrow[lang]} title={t.title[lang]} subtitle={t.subtitle[lang]} data-id="element-470" />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-471">
          {items.map((item, i) => {
          const Icon = icons[i];
          return <Card key={item.title} hover delay={i * 0.04} className="p-6 group" data-id="element-472">
                <div className="w-10 h-10 flex items-center justify-center bg-navy-deep rounded-sm mb-4" data-id="element-473">
                  <Icon className="w-4.5 h-4.5 text-gold" data-id="element-474" />
                </div>
                <h3 className="text-navy-deep text-[15px] font-medium leading-snug mb-2" data-id="element-475">
                  {item.title}
                </h3>
                <p className="text-[12.5px] text-slate-500 leading-relaxed mb-3" data-id="element-476">
                  {item.body}
                </p>
                <Link to="/contact" className="inline-flex items-center gap-1.5 font-mono text-[10.5px] tracking-wider text-gold-deep group-hover:gap-2 transition-all" data-id="element-477">
                  {c.contactForPricing[lang]}
                  <ArrowRightIcon className="w-3 h-3" data-id="element-478" />
                </Link>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}